import { createSlice } from '@reduxjs/toolkit'

import { fetchDialogs, fetchMessagesByDialogId } from './extraReducers'

const slice = createSlice({
    name: 'dialogs',
    initialState: {
        data: [] as any[],
        selectedDialog: null as any,
        isDialogsLoading: true,
        isMessagesLoading: true
    },
    reducers: {
        selectDialogRoutine: (state, action) => {
            state.selectedDialog = action.payload
        },
        addDialogMessageRoutine: (state, action) => {
            state.data = state.data.map((dialog: any) => {
                if (dialog.id === action.payload?.dialogId) {
                    let msgs = dialog.messages
                    msgs.push(action.payload)
                    return {
                        ...dialog,
                        messages: msgs
                    }
                }
                return dialog
            })
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchDialogs.fulfilled, (state, action) => {
                state.data = action.payload as any
                state.isDialogsLoading = false
            })
            .addCase(fetchDialogs.pending, (state) => {
                state.isDialogsLoading = true
            })
            .addCase(fetchDialogs.rejected, (state) => {
                state.isDialogsLoading = false
            })
            .addCase(fetchMessagesByDialogId.fulfilled, (state, action) => {
                const payload = action.payload as any
                state.data = state.data.map((dialog: any) => {
                    if (dialog.id === payload[0]?.dialogId) {
                        return {
                            ...dialog,
                            messages: payload
                        }
                    }
                    return dialog
                })
                state.isMessagesLoading = false
            })
            .addCase(fetchMessagesByDialogId.pending, (state) => {
                state.isMessagesLoading = true
            })
            .addCase(fetchMessagesByDialogId.rejected, (state) => {
                state.isMessagesLoading = false
            })
    }
})

export const { selectDialogRoutine, addDialogMessageRoutine } = slice.actions

export default slice.reducer
